import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

export const GET_PROVIDER = gql`
    query getProvider(
        $providerId: String
        $carrierId: String!
        $planId: String!
        $locationId: String
    ) {
        provider(id: $providerId) {
            acceptsInsurance(
                carrierId: $carrierId
                planId: $planId
                locationId: $locationId
            )
        }
    }
`;

export default graphql(GET_PROVIDER, {
    skip: (ownProps) => {
        return (
            !ownProps.providerId ||
            !ownProps.carrierId ||
            !ownProps.planId ||
            parseInt(ownProps.planId, 10) < 0
        );
    },
    options: (ownProps) => ({
        variables: {
            providerId: `${ownProps.providerId}`,
            carrierId: `${ownProps.carrierId}`,
            planId: `${ownProps.planId}`,
            locationId: ownProps.locationCloudId
                ? `${ownProps.locationCloudId}`
                : null,
        },
    }),
    props: ({ data }) => {
        if (data.loading) return { insuranceIsValidating: true };
        if (data.error || !data.provider) return;

        return {
            insuranceIsAccepted: data.provider.acceptsInsurance,
            insuranceIsValidating: false,
        };
    },
});
